module.exports = __webpack_public_path__ + "img/xmas_h.b4ee8cce.png";